import { useState } from "react";
import { stepDuration } from "../core/units";
import { useBack } from "./back";
import { formatDuration, t } from "./texts";

const PRESETS = [20, 30, 40, 45, 60, 90, 120, 180];

/**
 * Time picker as a bottom sheet: minutes and seconds columns with big ▲/▼ buttons (seconds in 5 s steps) and
 * presets for common times. Used for set durations; an optional target can be cleared.
 */
export function DurationPicker(props: {
  title: string;
  value: number | undefined;
  /** shown when there is no value yet */
  fallback: number;
  optional?: boolean;
  onPick(sec: number | undefined): void;
  onCancel(): void;
}) {
  const [sec, setSec] = useState(props.value ?? props.fallback);
  useBack(props.onCancel);
  const column = (part: "min" | "sec", value: number, label: string) => (
    <div className="time-col">
      <button className="secondary" aria-label={`${label} +`} onClick={() => setSec((s) => stepDuration(s, part, 1))}>▲</button>
      <span className="time-digits">{String(value).padStart(2, "0")}</span>
      <button className="secondary" aria-label={`${label} −`} onClick={() => setSec((s) => stepDuration(s, part, -1))}>▼</button>
      <span className="sub">{label}</span>
    </div>
  );

  return (
    <div className="overlay" onClick={props.onCancel}>
      <div className="dialog sheet" role="dialog" onClick={(e) => e.stopPropagation()}>
        <h2 className="sheet-title">{props.title}</h2>
        <div className="time-picker">
          {column("min", Math.floor(sec / 60), t.timePicker.minutes)}
          <span className="time-colon">:</span>
          {column("sec", sec % 60, t.timePicker.seconds)}
        </div>
        <div className="presets">
          {PRESETS.map((p) => (
            <button key={p} className={"secondary" + (p === sec ? " active" : "")} onClick={() => setSec(p)}>{formatDuration(p)}</button>
          ))}
        </div>
        <div className="row">
          {props.optional && <button className="secondary" onClick={() => props.onPick(undefined)}>{t.timePicker.clear}</button>}
          <button className="primary" onClick={() => props.onPick(sec)}>{t.timePicker.apply}</button>
        </div>
        <button className="ghost" onClick={props.onCancel}>{t.cancel}</button>
      </div>
    </div>
  );
}
